import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CbCurrencyModule, CbInputModule, CbSelectChoiceModule, CbToggleModule } from '@chubb/ui-components';
import { SelectModule } from 'primeng/select';
import { BaseCoverageWidgetComponent } from '../../../../shared/components/base-coverage.widget.component';
import { RemoveCoverComponent } from '../../remove-cover/remove-cover.component';
import { RulesErrorCoverageComponent } from '../../rules-error-coverage/rules-error-coverage.component';
import { UnderwritingTermsComponent } from '../../underwriting-terms/underwriting-terms.component';

@Component({
  selector: 'app-assurance-extra-life-cover',
  imports: [
    CommonModule,
    CbInputModule,
    CbCurrencyModule,
    CbSelectChoiceModule,
    SelectModule,
    CbToggleModule,
    ReactiveFormsModule,
    UnderwritingTermsComponent,
    RemoveCoverComponent,
    RulesErrorCoverageComponent,
  ],
  templateUrl: './assurance-extra-life-cover.component.html',
  styleUrl: './assurance-extra-life-cover.component.scss',
})
export class AssuranceExtraLifeCoverComponent extends BaseCoverageWidgetComponent {}
